import { createFileRoute } from "@tanstack/react-router";
import StudyChecklist from "@/pages/resources/StudyChecklist";

export const Route = createFileRoute("/learn/study-checklist")({
  head: () => ({
    meta: [
        {
            "title": "Study Session Checklist: Optimize Every Session | System Atlas"
        },
        {
            "name": "description",
            "content": "A practical checklist for effective study sessions. Use this template before, during, and after studying to maximize retention and minimize wasted time."
        },
        {
            "property": "og:title",
            "content": "Study Session Checklist: Optimize Every Session | System Atlas"
        },
        {
            "property": "og:description",
            "content": "A practical checklist for effective study sessions. Use this template before, during, and after studying to maximize retention and minimize wasted time."
        },
        {
            "property": "og:type",
            "content": "article"
        },
        {
            "property": "og:url",
            "content": "https://systematlas.fr/learn/study-checklist"
        },
        {
            "property": "og:image",
            "content": "https://storage.googleapis.com/gpt-engineer-file-uploads/fixHLaYpiGQriTbTH3NKQDMP9X13/social-images/social-1776280806353-Screenshot_2026-04-15_at_21.19.52.webp"
        },
        {
            "name": "twitter:card",
            "content": "summary_large_image"
        },
        {
            "name": "twitter:title",
            "content": "Study Session Checklist: Optimize Every Session | System Atlas"
        },
        {
            "name": "twitter:description",
            "content": "A practical checklist for effective study sessions. Use this template before, during, and after studying to maximize retention and minimize wasted time."
        },
        {
            "name": "twitter:image",
            "content": "https://storage.googleapis.com/gpt-engineer-file-uploads/fixHLaYpiGQriTbTH3NKQDMP9X13/social-images/social-1776280806353-Screenshot_2026-04-15_at_21.19.52.webp"
        }
    ],
    links: [
        {
            "rel": "canonical",
            "href": "https://systematlas.fr/learn/study-checklist"
        },
        {
            "rel": "alternate",
            "hrefLang": "en",
            "href": "https://systematlas.fr/learn/study-checklist"
        },
        {
            "rel": "alternate",
            "hrefLang": "fr",
            "href": "https://systematlas.fr/fr/learn/study-checklist"
        },
        {
            "rel": "alternate",
            "hrefLang": "x-default",
            "href": "https://systematlas.fr/learn/study-checklist"
        }
    ],
  }),
  component: StudyChecklist,
});
